import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { UploadFile, ContainerBox, ModalFooter, Table } from "components";
import {
  MODAL_ID, MODAL_TYPE, EMPTY_FORMAT_CELL, CONFIG_FILE_EDITION, FORM_SETTING_EDITION,
  PREBUILT_MODELS, STORAGE_KEYS, PREBUILT_MODEL_CODE
} from '../../core/utils/constants';
import { RiDeleteBin5Line } from "react-icons/ri";
import { LoadingUpload } from "../../lotties";
import "./style.scss";
import URL_CONFIG from '../../core/services/config';
import { Browser } from '../../core/utils';

@inject("commonStore", "documentsStore", "modalStore")
@observer
class ScreenUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      fileContent: null
    };
  }

  /**
   * handleBackButton
   * go edit screen
   * @param {int} id: id of document
   * 
   * @returns redirect to edit screen
   */
  handleBackButton = () => {
    this.props.documentsStore.deleteUploadFile(this.props.history)
  };


  /**
   * handleAddFile
   * @param {Array} files: list of chosen file
   * 
   * @returns rerender
   */
  handleAddFile = (file, fileContent) => {
    if (!this.props.documentsStore.updateFileContent(file)) {
      this.openModalError();
    }
  };

  openModalError = () => {
    const { modalStore, t } = this.props;
    const isIE = /MSIE|Trident/.test(window.navigator.userAgent);
    modalStore.show({
      id: MODAL_ID.CONFIRM,
      isOpen: true,
      header: t("upload.cant_upload_warning"),
      onCancel: this.closeModal,
      children: (
        <div className="text-c">
          {/* The iframe below is used to fix bug in the browser IE11.
          In the screen [Upload], the pdf iframe is overlap all elements. */}
          {isIE && <iframe class="iframe-cover-ar" src="about:blank"></iframe>}
          <div key={"modal-body"} className="modal-body">
            <span>{t("upload.cant_upload_filenum")}</span>
          </div>
          <ModalFooter
            key={"modal-footer"}
            saveButtonText={t("upload.close")}
            onConfirm={() => {
              this.closeModal();
            }}
            saveButtonClass="btn-primary"
          />
        </div>
      ),
      type: "small",
    });
  };

  handleUploadButton = () => {
    if (document.getElementById("upload-selector")) {
      document.getElementById("upload-selector").click();
    }
  }

  /**
   * handleDefinitationChange
   * @param {Int} value: new config Id
   * 
   * @returns rerender
   */
  handleDefinitationChange = (value, save = true) => {
    if (value) {
      this.props.documentsStore.updateSelectedDefinitionId(value, save);
    }
  }

  /**
   * handlePrebuiltFormTypeChange
   * @param {Int} value: new config Id
   * 
   * @returns rerender
   */
  handlePrebuiltFormTypeChange = (value, save = true) => {
    if (value) {
      this.props.documentsStore.updateSelectedPrebuiltFormType(value, save);
    }
  }

  handleAIFormTypeChange = (value, save = true) => {
    if (value) {
      this.props.documentsStore.updateSelectedAIFormType(value, save);
    }
  }

  handleClaudeSettingChange = (value, save = true) => {
    if (value) {
      this.props.documentsStore.updateSelectedClaudeSetting(value, save);
    }
  }

  handleTeamChange = (value, save = true) => {
    if (value) {
      this.props.documentsStore.updateSelectedTeamId(value, save);
    }
  }

  handleSortDefinitionChange = (value, save = true) => {
    if (value) {
      this.props.documentsStore.updateSortDefinition(value, save);
    }
  }

  onRead = () => {
    const {
      commonStore: { FileStore }
    } = this.props;
    FileStore.read();
  };

  /**
   * closeModal
   * close confirmation dialogue
   * 
   */
  closeModal = () => {
    const { modalStore } = this.props;
    modalStore.hide();
  };

  /**
   * openComfirmExecuteReading
   * to make sure user want to execute
   * 
   */
  openComfirmExecuteReading = () => {
    const { modalStore, documentsStore, t } = this.props;
    const isIE = /MSIE|Trident/.test(window.navigator.userAgent);
    modalStore.show({
      id: MODAL_ID.CONFIRM,
      isOpen: true,
      header: t("upload.confirmation"),
      onCancel: () => this.closeModal(MODAL_ID.CONFIRM),
      children: (
        <div className="text-c">
          {/* The iframe below is used to fix bug in the browser IE11.
          In the screen [Upload], the pdf iframe is overlap all elements. */}
          {isIE && <iframe class="iframe-cover-ar" src="about:blank"></iframe>}
          <div key={"modal-body"} className="modal-body">
            <span>{t("upload.confirm_desc")}</span>
          </div>
          <ModalFooter key={"modal-footer"}
            saveButtonText={t("upload.execute")}
            onConfirm={() => {
              this.closeModal();
              documentsStore.executeCurrentDocument(this.props.history);
            }}
            cancelButtonText={t("upload.cancel")}
            onCancel={this.closeModal}
          />
        </div>
      ),
      type: MODAL_TYPE.SMALL,
    });
  };

  deleteFile = (fileName, timestamp) => {
    const { modalStore, documentsStore, t } = this.props;
    const isIE = /MSIE|Trident/.test(window.navigator.userAgent);
    modalStore.show({
      id: MODAL_ID.CONFIRM_DELETE,
      isOpen: true,
      header: t("upload.confirmation_delete"),
      onCancel: () => this.closeModal(MODAL_ID.CONFIRM_DELETE),
      children: (
        <div className="text-c">
          {/* The iframe below is used to fix bug in the browser IE11.
          In the screen [Upload], the pdf iframe is overlap all elements. */}
          {isIE && <iframe class="iframe-cover-ar" src="about:blank"></iframe>}
          <div key={"modal-body"} className="modal-body">
            <span>{t("upload.confirm_delete_desc")}</span>
          </div>
          <ModalFooter key={"modal-footer"}
            saveButtonText={t("upload.remove")}
            onConfirm={() => {
              this.closeModal();
              documentsStore.deleteUploadedFile(encodeURIComponent(fileName), timestamp);
            }}
            cancelButtonText={t("upload.cancel")}
            onCancel={this.closeModal}
          />
        </div>
      ),
      type: MODAL_TYPE.SMALL,
    });
  }

  async componentDidMount() {
    const { documentsStore, commonStore: { formSettingStore, teamStore, settingStore } } = this.props;
    //const { commonStore: { templateSortingStore } } = this.props;
    documentsStore.cleanCurrentFile();
    documentsStore.clean();
    documentsStore.getDefinitationsInTeam();
    documentsStore.getDefinitationsGroupInTeam();
    documentsStore.getTemplateSortingsForUpload();
    formSettingStore.getAll(() => {
      let claudeSetting = Browser.getSavedInfo(STORAGE_KEYS.UPLOAD_CLAUDE_SETTING);
      let storaged = this.props.commonStore.formSettingStore.claude35Settings?.settingBody?.settings?.filter(e => { return parseInt(e.id) === parseInt(claudeSetting) });
      if (storaged && storaged[0]) {
        this.handleClaudeSettingChange(String(storaged[0].id), false);
      } else {
        this.handleClaudeSettingChange("-1", false);
      }
    });
    settingStore.getSetting();
    await teamStore.getTeamOfUser().then(() => {
      if (teamStore.teamsOfUser && teamStore.teamsOfUser.length > 0) {
        let team = Browser.getSavedInfo(STORAGE_KEYS.UPLOAD_TEAM);
        let storaged = teamStore.teamsOfUser.filter(e => e.id == team);

        if (storaged && storaged[0]) {
          documentsStore.setSelectedTeamId(storaged[0]?.id, false);
        } else {
          documentsStore.setSelectedTeamId(teamStore.teamsOfUser[0]?.id, false);
        }
      }
    });

    // localStorageから帳票定義設定を取得して初期状態として設定する
    let edition = Browser.getSavedInfo(STORAGE_KEYS.UPLOAD_EDITION);
    if (edition !== null && edition !== undefined) {
      this.handleSelectFilter(edition, false);
    }
  }

  componentDidUpdate = () => {
    const { t, documentsStore: { selectedDefinitionId } } = this.props;
    let elements = document.getElementsByClassName("btn-execute-reading");
    if (elements && elements[0]) {
      if (this.props.documentsStore?.currentUploadFile?.readyToExecute && selectedDefinitionId !== -1) {
        elements[0].removeAttribute("title");
      } else {
        elements[0].setAttribute("title", selectedDefinitionId === -1 ? t("upload.upload_definition_to_execute_reading") : t("upload.upload_file_to_execute_reading"));
      }
    }
  }

  columns = () => {
    const { t, documentsStore: { setCurrentUploadFile } } = this.props;
    return [
      {
        Header: t("upload.no"),
        accessor: "no",
        Cell: ({ row }) => {
          return <div>{(parseInt(row.id) + 1)}</div>;
        },
        width: "6%",
        disableSortBy: true
      },
      {
        Header: t("upload.filename"),
        accessor: "name",
        Cell: ({ row }) => {
          const fileData = row.original.data || row.original;
          return fileData.status
            ? <div className="file-name single-line-row finished-item" onClick={() => setCurrentUploadFile(fileData.upload_id)} title={fileData.name} >{fileData.name}</div>
            : <div className="file-name single-line-row" title={fileData.name}>{fileData.name}</div>;
        },
        width: "44%",
        disableSortBy: true
      },
      {
        Header: t("upload.format"),
        accessor: "type",
        Cell: ({ row }) => {
          const fileData = row.original.data || row.original;
          return fileData.status ? <div>{fileData.type.split("/").slice(-1).pop()}</div> : <span>{EMPTY_FORMAT_CELL}</span>;
        },
        width: "10%",
        disableSortBy: true
      },
      {
        Header: t("upload.size"),
        accessor: "size",
        width: "20%",
        Cell: ({ row }) => {
          const fileData = row.original.data || row.original;
          return fileData.status ? <div className="single-line-row" title={fileData.size}>{fileData.size}</div> : <span>{EMPTY_FORMAT_CELL}</span>;
        },
        disableSortBy: true
      },
      {
        Header: t("upload.status"),
        accessor: "status",
        Cell: ({ row }) => {
          const fileData = row.original.data || row.original;
          return fileData.status ? <div><i className="fa fa-check"></i></div> : <div className="loading-file-status"><LoadingUpload></LoadingUpload></div>;
        },
        width: "10%",
        disableSortBy: true
      },
      {
        Header: t("upload.action"),
        accessor: "action",
        className: 'upload-action',
        Cell: ({ row }) => {
          const fileData = row.original.data || row.original;
          return <div><RiDeleteBin5Line className={fileData.status ? "" : "disabled"} onClick={() => fileData.status && this.deleteFile(fileData.name, fileData.timestamp)}></RiDeleteBin5Line></div>;
        },
        width: "10%",
        disableSortBy: true
      }
    ];
  };

  handleSelectFilter = (value, save = true) => {
    console.log("handleSelectFilter -> value", value)
    const { documentsStore: { listGroupDefinitions, updateSortDefinition, selectedGroupId, updateSelectedGroupId,
      listTemplateSortings, selectedTemplateSortingId, updateSelectedTemplateSortingId } } = this.props;
    //const { commonStore: { templateSortingStore: { templateSortingsForUpload } } } = this.props;
    updateSortDefinition(value, save);
    if (value === 0 || value === 2) {
      if (listGroupDefinitions[0] && selectedGroupId === null) {
        updateSelectedGroupId(listGroupDefinitions[0]?.id, save);
      }
    }
    if (value === 0 || value === 1) {
      if (listTemplateSortings[0] && selectedTemplateSortingId === null) {
        updateSelectedTemplateSortingId(listTemplateSortings[0]?.id, save);
      }
    }

    // } else {
    //   this.setState({ formGroup: null });
    //   this.handleDefinitationChange(documentsStore.listAllDefinitions[0].id);
    // }
  }

  handleGroupDefinitionChange = (value, save) => {
    const { documentsStore: { updateSelectedGroupId } } = this.props;
    updateSelectedGroupId(value, save);
    // this.handleDefinitationChange(documentsStore.listAllDefinitions?.filter(e => e.formGroupId === parseInt(value))[0].id);
  }

  handleTemplateSortingSettingChange = (value, save) => {
    const { documentsStore: { updateSelectedTemplateSortingId } } = this.props;
    updateSelectedTemplateSortingId(value, save);
  }

  openFormSetting = () => {
    const { documentsStore: { selectedPrebuiltFormType } } = this.props;
    let query = '';
    if (selectedPrebuiltFormType == PREBUILT_MODEL_CODE.INVOICE) {
      query = '?edition=' + FORM_SETTING_EDITION.PREBUILT + '&form=' + PREBUILT_MODELS.INVOICE;
    } else if (selectedPrebuiltFormType == PREBUILT_MODEL_CODE.RECEIPT) {
      query = '?edition=' + FORM_SETTING_EDITION.PREBUILT + '&form=' + PREBUILT_MODELS.RECEIPT;
    }
    this.props.history.push({
      pathname: '/formsetting',
      search: query,
    });
  }

  openAISetting = (value) => {
    this.props.history.push({
      pathname: '/aisetting',
    });
  }

  render() {
    const { t, documentsStore, documentsStore: { selectedDefinitionId, selectedGroupId, selectedTemplateSortingId, sortDefinition,
      listGroupDefinitions, selectedTeamId, listTemplateSortings, selectedPrebuiltFormType, selectedAIFormType, selectedClaudeSetting },
      commonStore: { formSettingStore: { claude35Settings }, teamStore, settingStore } } = this.props;
    //const { commonStore: { templateSortingStore: { templateSortingsForUpload } } } = this.props;
    return (
      <ContainerBox headerTitle={t("upload.report_upload")} className="screen-upload">
        <div className="screen-upload-body">
          <div className="box-body box-profile col-sm-6 su-column su-upload-pannel">
            <div className="su-sub-upload-pannel">
              <div className="su-upload-file">
                <button type="button" className="btn btn-primary upload-button" onClick={this.handleUploadButton}>
                  {t("upload.btn_select_file")}
                </button>
                <UploadFile file={documentsStore?.currentUploadFile?.content} addFile={this.handleAddFile} mime={"application/pdf, .jpg, .tiff, .png"} />
              </div>
              <div className="wrap-upload-file-list">
                <div className="upload-file-list styled-scroll">
                  {<Table
                    disablePaging={true}
                    columns={this.columns()}
                    data={documentsStore.uploadingFiles}
                    rowClass={(row) => {
                      const fileData = row.original.data || row.original;
                      return documentsStore?.currentUploadFile.upload_id === fileData.upload_id ? "selected-item" : "";
                    }}
                    t={t}
                    disableSelectionPageSize={true}
                    hideTableFooter={true}
                    className="uploading-table"
                  />}
                  {documentsStore.uploadingFiles.length === 0 && <div className="table-no-data">
                    <p>{t("table_no_data")}</p>
                  </div>}
                </div>
                <div className="row profile-item">
                  <div className="col-sm-3 select-def-label" >
                    <div style={{ marginLeft: "8px" }}>{t("upload.read_method")}</div>
                  </div>
                  <div className="col-sm-9 profile-value">
                    <select
                      id="select-read-method"
                      className="file-config"
                      value={sortDefinition}
                      onChange={(e) => this.handleSelectFilter(e.target?.value)}
                    >
                      <option key="0" value="0">{t("upload.definition_file")}</option>
                      <option key="1" value="1">{t("upload.group_definition_filter")}</option>
                      <option key="2" value="2">{t("upload.template_sorting_filter")}</option>
                      {URL_CONFIG.is_connect_to_azure_app_insight === true &&
                        <option key="3" value="3">{t("upload.prebuilt_definition")}</option>
                      }
                      {URL_CONFIG.is_connect_to_azure_app_insight === true &&
                        <option key="4" value="4">{t("upload.ai_reading")}</option>
                      }
                    </select>
                  </div>
                </div>
                {sortDefinition === "0" &&
                  <div className="row profile-item">
                    <div className="col-sm-3 select-def-label">
                      <div style={{ marginLeft: "8px" }}>{t("upload.form_id")}</div>
                    </div>
                    <div className="col-sm-9 profile-value">
                      <select
                        id="select-form-id"
                        className="file-config"
                        value={selectedDefinitionId}
                        onChange={(e) => this.handleDefinitationChange(e.target?.value)}
                      >
                        {
                          documentsStore.listAllDefinitions?.filter((def) => {
                            return def.edition != CONFIG_FILE_EDITION.PREBUILT
                          }).map((def) => {
                            return <option key={def.id} value={def.id}>{def.configName} [{def.formGroupName}]</option>
                          })
                        }
                      </select>
                    </div>
                  </div>
                }
                {sortDefinition === "1" &&
                  <div className="row profile-item">
                    <div className="col-sm-3 select-def-label" >
                      <div style={{ marginLeft: "8px" }}>{t("upload.group_name")}</div>
                    </div>
                    <div className="col-sm-9 profile-value">
                      <select
                        id="select-group"
                        className="file-config"
                        value={selectedGroupId}
                        onChange={(e) => this.handleGroupDefinitionChange(e.target?.value)}
                      >
                        {listGroupDefinitions?.map(e => <option key={e.id} value={e.id}>{e.groupName}</option>)}
                      </select>
                    </div>
                  </div>
                }
                {sortDefinition === "2" &&
                  <div className="row profile-item">
                    <div className="col-sm-3 select-def-label" >
                      <div style={{ marginLeft: "8px" }}>{t("upload.sorting_template")}</div>
                    </div>
                    <div className="col-sm-9 profile-value">
                      <select
                        id="select-sorting-template"
                        className="file-config"
                        value={selectedTemplateSortingId}
                        onChange={(e) => this.handleTemplateSortingSettingChange(e.target?.value)}
                      >
                        {listTemplateSortings?.map(e => <option key={e.id} value={e.id}>{e.settingName}</option>)}
                      </select>
                    </div>
                  </div>
                }
                {URL_CONFIG.is_connect_to_azure_app_insight === true && sortDefinition === "3" &&
                  <div className="row profile-item">
                    <div className="col-sm-3 select-def-label">
                      <div style={{ marginLeft: "8px" }}>{t("upload.prebuilt_model")}</div>
                    </div>
                    <div className="col-sm-9 profile-value">
                      <select
                        id="select-prebuilt-model"
                        className="file-config"
                        value={selectedPrebuiltFormType}
                        onChange={(e) => this.handlePrebuiltFormTypeChange(e.target?.value)}
                      >
                        {
                          documentsStore.listAvailablePrebuiltModels.map((def) => {
                            let configName = "";
                            if (def.id == PREBUILT_MODEL_CODE.INVOICE) {
                              configName = t("upload.prebuilt_invoice");
                            } else if (def.id == PREBUILT_MODEL_CODE.RECEIPT) {
                              configName = t("upload.prebuilt_receipt");
                            }
                            return <option key={def.id} value={def.id}>{configName}</option>
                          })
                        }
                      </select>
                    </div>
                  </div>
                }
                {URL_CONFIG.is_connect_to_azure_app_insight === true && sortDefinition === "3" &&
                  <div className="row profile-item">
                    <div className="col-sm-3 select-def-label">
                    </div>
                    <div className="col-sm-9 profile-value">
                      <span
                        onClick={() => { this.openFormSetting() }}
                        onKeyDown={(e) => { if (e.key === "Enter") this.openFormSetting(); }}
                        role="button"
                        tabIndex="0">
                        {t("upload.prebuilt.setting_link")}
                      </span>
                    </div>
                  </div>
                }
                {URL_CONFIG.is_connect_to_azure_app_insight === true && sortDefinition === "4" &&
                  <div className="row profile-item">
                    <div className="col-sm-3 select-def-label">
                      <div style={{ marginLeft: "8px" }}>{t("upload.ai_model")}</div>
                    </div>
                    <div className="col-sm-9 profile-value">
                      <select
                        id="select-ai-model"
                        className="file-config"
                        value={selectedAIFormType}
                        onChange={(e) => this.handleAIFormTypeChange(e.target?.value)}
                      >
                        {
                          documentsStore.listAvailableAIModels.map((def) => {
                            return <option key={def.id} value={def.id}>{def.configName}</option>
                          })
                        }
                      </select>
                    </div>
                  </div>
                }
                {URL_CONFIG.is_connect_to_azure_app_insight === true && sortDefinition === "4" &&
                  <div className="row profile-item">
                    <div className="col-sm-3 select-def-label">
                    </div>
                    <div className="col-sm-9 profile-value">
                      <span
                        onClick={() => { this.openAISetting() }}
                        onKeyDown={(e) => { if (e.key === "Enter") this.openAISetting(); }}
                        role="button"
                        tabIndex="0">
                        {t("upload.prebuilt.setting_link")}
                      </span>
                    </div>
                  </div>
                }
                {URL_CONFIG.is_connect_to_azure_app_insight === true && sortDefinition === "4" &&
                  <div className="row profile-item">
                    <div className="col-sm-3 select-def-label">
                      <div style={{ marginLeft: "8px" }}>{t("upload.ai_setting")}</div>
                    </div>
                    <div className="col-sm-9 profile-value">
                      <select
                        id="select-claude-setting"
                        className="file-config"
                        value={selectedClaudeSetting}
                        onChange={(e) => this.handleClaudeSettingChange(e.target?.value)}
                      >
                        <option key="-1" value="-1">{t("upload.ai_auto_sorting")}</option>
                        {claude35Settings?.settingBody?.settings?.map(e => <option key={e.id} value={e.id}>{e.settingName}</option>)}
                      </select>
                    </div>
                  </div>
                }
                {/* Team name */}
                <div className="row profile-item">
                  <div className="col-sm-3 select-def-label">
                    <div style={{ marginLeft: "8px" }}>{t("team.team_name")}</div>
                  </div>
                  <div className="col-sm-9 profile-value">
                    <select id="select-team" className="file-config" value={selectedTeamId} onChange={(e) => this.handleTeamChange(e.target?.value)}>
                      {
                        teamStore.teamsOfUser?.map((team) => {
                          return <option key={team.id} value={team.id}>{team.name}</option>
                        })
                      }
                    </select>
                  </div>
                </div>
                <div className="action-group">
                  <button type="button" className="btn btn-danger" onClick={this.handleBackButton}>
                    {t("upload.cancel")}
                  </button>
                  <button
                    title={(selectedDefinitionId === -1) ? t("upload.upload_definition_to_execute_reading") : t("upload.upload_file_to_execute_reading")}
                    type="button" className="btn-execute-reading btn btn-primary"
                    onClick={this.openComfirmExecuteReading}
                    disabled={!documentsStore?.currentUploadFile?.readyToExecute || selectedDefinitionId === -1 || selectedTeamId === -1}
                  >
                    {t("upload.execute_reading")}
                  </button>
                </div>
              </div>
            </div>
            {/* {documentsStore.listAllDefinitions.find(e => e.id === selectedDefinitionId)?.edition === "Manual" && <ReactTooltip
              id="main"
              place="top"
              type="dark"
              effect="solid"
              multiline={true}
            >
              {t("upload.sort_definition_tooltip_1")}
            </ReactTooltip>} */}
          </div>
          <div className="box-body box-profile col-sm-6 su-column su-preview">
            <iframe
              className="uploaded-file-iframe"
              frameBorder="0"
              title="uploaded-file"
              src={documentsStore?.currentUploadFile?.link}
            />
          </div>
        </div>
      </ContainerBox >
    );
  }
}
export default withRouter(withTranslation()(ScreenUpload));
